import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SubjectApi } from './subject-api';
import { ServiceApi } from '../genericApi/service-api';

@NgModule({ imports: [], providers: [
        SubjectApi,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SubjectApiModule{}
